import { clamp } from './math.js'

/** 시킹 갱신 임계. 이보다 작은 차이는 무시한다 (디자인 원본과 동일). */
export const SEEK_EPSILON = 0.04
/** 영상 끝에 남기는 여유. 마지막 프레임에서 멈추는 브라우저가 있다. */
export const SEEK_TAIL = 0.05

/**
 * 스크럽 섹션의 진행률.
 * `top`은 getBoundingClientRect().top, `height`는 섹션 전체 높이(예: 400vh)다.
 */
export function computeScrollProgress(top: number, height: number, viewportHeight: number): number {
  const travel = Math.max(1, height - viewportHeight)
  return clamp(-top / travel, 0, 1)
}

export function videoSeekTarget(progress: number, duration: number): number {
  if (!Number.isFinite(duration) || duration <= 0) return 0
  return clamp(progress * duration, 0, Math.max(0, duration - SEEK_TAIL))
}

export function shouldSeek(current: number, target: number): boolean {
  return Math.abs(current - target) > SEEK_EPSILON
}
